// Alternative simpler SimilarProductItem.jsx
import React, { useState, useEffect } from 'react';
import product1 from '../images/Home/product2.webp';
import heart from '../images/Home/heart.png';
import filledHeart from '../images/Home/heart2.png';

const PromotionTags = ({ product }) => {
    return (
        <div className="flex flex-wrap gap-1 mb-1">
            {product.BestSeller === 1 && (
                <span className="bg-orange-100 text-orange-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    Best Seller
                </span>
            )}
            {product.LimitedSale === 1 && (
                <span className="bg-rose-100 text-rose-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    Limited Sale
                </span>
            )}
            {product.NewArrivals === 1 && (
                <span className="bg-sky-100 text-sky-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    New Arrival
                </span>
            )}
        </div>
    );
};

const SimilarProductItem = ({
    product,
    isVisible,
    productImageUrl,
    wishlistItems,
    removeFromWishlist,
    addToWishlist,
    fullimage,
    index
}) => {
    const [currentImage, setCurrentImage] = useState(product1);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (productImageUrl) {
            // Preload the image
            const img = new Image();
            img.src = productImageUrl;

            img.onload = () => {
                setCurrentImage(productImageUrl);
                setIsLoading(false);
            };

            img.onerror = () => {
                setCurrentImage(product1);
                setIsLoading(false);
            };
        } else {
            // If no URL provided, use fallback
            setCurrentImage(product1);
            setIsLoading(false);
        }
    }, [productImageUrl]);

    return (
        <div
            className={`flex flex-col gap-3 group cursor-pointer transition-all duration-400 ease-out transform ${isVisible
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-10'
                }`}
            onClick={() => fullimage(product.ID, product.ItemName)}
        >
            <div className='aspect-[3/4] rounded-2xl font-montserrat bg-gray-50 flex items-center justify-center relative overflow-hidden'>
                {/* Product image */}
                <img
                    src={currentImage}
                    alt={product.ItemName}
                    className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 ${!isLoading ? 'opacity-100' : 'opacity-0'
                        }`}
                />

                <div className='absolute top-4 right-4'>
                    <button
                        className={`w-10 h-10 rounded-full flex justify-center items-center shadow-sm transition-all transform hover:scale-110 active:scale-90 ${wishlistItems.some(item => item.ID === product.ID)
                            ? 'bg-black text-white'
                            : 'bg-white/80 backdrop-blur-sm text-black hover:bg-white'
                            }`}
                        onClick={(e) => {
                            e.stopPropagation();
                            wishlistItems.some(item => item.ID === product.ID)
                                ? removeFromWishlist(product.ID)
                                : addToWishlist(product);
                        }}
                    >
                        <img
                            src={wishlistItems.some(item => item.ID === product.ID) ? filledHeart : heart}
                            alt="heart"
                            className={`w-5 h-5 ${wishlistItems.some(item => item.ID === product.ID) ? 'brightness-0 invert' : ''}`}
                        />
                    </button>
                </div>
            </div>

            <div className='flex flex-col gap-1 px-1 font-montserrat'>
                <PromotionTags product={product} />
                <h3 className='text-left text-sm font-semibold text-gray-900 line-clamp-1 group-hover:text-red-600 transition-colors uppercase'>
                    {product.ItemName}
                </h3>
                <div className='flex items-center gap-2'>
                    <span className='text-lg font-bold text-black text-left'>₹{product.MRP}</span>
                    {/* {product.MOP > 0 && product.MOP < product.MRP && (
                        <span className='text-sm text-gray-400 line-through'>₹{product.MOP}</span>
                    )} */}
                </div>
            </div>
        </div>
    );
};

export default SimilarProductItem;